import { actions } from '../../utils/constants';

const DEFAULT_STATE = [];

export default (state = DEFAULT_STATE, { type, payload }) => {

    switch (type) {

    case actions.CENTERS_FETCHED:
        return payload;

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/centers/centers.reducer.js